// Hook for SSO login via parent window.
import { setSSOParentLoginToken } from 'platform-specific/ssoinjection';
import { getIsInPsiNativeAppWebview } from 'platform-specific/url';
import { useEffect } from 'react';
import { callServerApiAsync } from "system/servercall"
import { signInWithTokenAsync } from 'internal/firebase'
import { getIsInAndroid, getIsInIFrame, getIsInIOS, logUnlessTest } from 'util/util'
import { NativeWindow } from './webview';


// FIXME: This function is too large and should be broken up
/* eslint-disable-next-line max-lines-per-function */
export function useSSOLoginFromParent(siloKey) {
    logUnlessTest('SSO: useSSOLoginFromParent');
// FIXME: This function is too large and should be broken up
/* eslint-disable-next-line max-lines-per-function */
    useEffect(() => {
        logUnlessTest('SSO: useSSOLoginFromParent useEffect');
        const iframeMessageHandler = async (event) => {
            if (event?.data?.type === 'psi-sso-parent-login') {
                const { ssoToken, provider } = event?.data ?? {};
                logUnlessTest('SSO: Received ssoToken from parent');
                await hydrateSessionTokenFn(ssoToken, provider);
            }
        }

        const hydrateSessionTokenFn = async (ssoToken, provider) => {
            const result = await callServerApiAsync({
                component: 'auth', funcname: 'convertToken', params: {
                    ssoToken, provider, siloKey
                }
            });
            if (result?.loginToken) {
                if (result?.personaPreview?.name) {
                    await signInWithTokenAsync(result.loginToken);
                } else {
                    setSSOParentLoginToken(result.loginToken);
                }
            }
        };

        const hydrateSessionListener = async (event) => {
            const { ssoToken, provider } = event?.detail ?? {};
            await hydrateSessionTokenFn(ssoToken, provider);
        }

        document.addEventListener("nativeMessageEvent", hydrateSessionListener);
        window.addEventListener("message", iframeMessageHandler)

        const nativeWindow = window as NativeWindow;    

        if (getIsInPsiNativeAppWebview()) {
            logUnlessTest('SSO: Psi native app webview');
            if (getIsInAndroid(nativeWindow)) {
                logUnlessTest('SSO: Android app ready');
                nativeWindow.Android?.appReady();
            } else if (getIsInIOS(nativeWindow)) {
                logUnlessTest('SSO: IOS app ready');
                nativeWindow.webkit?.messageHandlers?.appReady?.postMessage('');
            }
        } else if (getIsInIFrame(nativeWindow)) {
            logUnlessTest('SSO: Iframe ready');
            window.parent.postMessage('psi-app-ready', '*');
        } else {
            logUnlessTest('SSO: Not in a webview or iframe');
        }

        return () => {
            document.removeEventListener('nativeMessageEvent', hydrateSessionListener);
            window.removeEventListener('message', iframeMessageHandler);
        };
    }, []);
};
